import styled from 'styled-components';

export const HomeCaroSliderWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    cursor: pointer;
    position: relative;
    height: 19.5rem;
  `,
);

export const HomeCaroSliderInnerWrap = styled.ul(
  props => `
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    li{
      width: 28.5rem;
      height: 19.5rem;
      display: flex;
      margin-right: ${props.theme.spacing.xlarge};
      background-color: ${props.theme.colors.white.base};
      border-radius: ${props.theme.misc.borderRadius.xxxlarge};
      flex-direction: column;
    }
  `,
);

export const SliderImg = styled.img(
  props => `
    width: 28.5rem;
    height: 10.8rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge} ${props.theme.misc.borderRadius.xxxlarge} 0 0;
    object-fit: cover;
  `,
);

export const SliderInfoWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 1rem 2rem;
  `,
);

export const SliderHeadInfoText = styled.p(
  props => `
    font-size: 1.4rem;
    color: black;
    line-height: 1.4;
  `,
);

export const SliderInfoSubText = styled.span(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.grey50};
      padding-top: ${props.theme.spacing.base};
    `,
);

export const SliderArrow = styled.button(
  props => `
      width: 4rem;
      height: 4rem;
      display: flex;
      border-radius: 50%;
      background-color: white;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      border:none;
      outline: 0;
      &.right {
        top: 50%;
        right: -1rem;
        transform: translateY(-50%);
      }
      &.left {
        top: 50%;
        left: -1rem;
        transform: translateY(-50%);
      }
    `,
);

